(function() {
    angular
        .module("app")
        .controller("MessageOverwriteWarningModalController", MessageOverwriteWarningModalController)

    MessageOverwriteWarningModalController.$inject = [
        "$stateParams",
        "$state",
        "$scope",
        "$uibModalInstance",
        "messagesService",
        "userMessagingService",
        "messageData",
        "messageID",
        "isActivate"
    ]

    function MessageOverwriteWarningModalController(
        $stateParams,
        $state,
        $scope,
        $uibModalInstance,
        messagesService,
        userMessagingService,
        messageData,
        messageID,
        isActivate
    ){
        "use strict"

        /**
            $scope variables
         **/
        $scope.messageData = messageData
        $scope.messageID = messageID
        $scope.isActivate = isActivate

        $scope.ok = function() {
            $scope.messageData.message.activate = $scope.isActivate

            $uibModalInstance.close(
                messagesService.editMessage(
                    $stateParams.message_board_id,
                    $scope.messageID,
                    $scope.messageData,
                    function(data) {
                        //Success
                        $state.go("device-message-board.details", {message_board_id: $stateParams.message_board_id}).then(() => {
                            userMessagingService.success("Message Overwrite Request Sent")
                        })
                    },
                    function(error) {
                        //Failure
                        $uibModalInstance.dismiss("cancel")
                        userMessagingService.error(error)
                    }
                )
            )
        }

        $scope.cancel = function() {
            $uibModalInstance.dismiss("cancel")
        }
    }
})()
